import { Button, Col, notification, Row, Switch } from "antd";
import { FormComponentProps } from "antd/lib/form";
import * as React from "react";
import { Dispatch, SetStateAction, useContext, useEffect, useState } from "react";
import { ShowNotification } from 'src/components/common/ShowNotification/ShowNotification';
import StandardButton from "src/components/common/StandardButton/StandardButton";

import { AuthContext } from "src/components/context/AuthContext";
import { PSSComponent } from "src/components/PricingComponents/PSSComponent/PSSComponent";
import { ReducedPercentLenderComponent } from "src/components/PricingComponents/ReducedPercentLenderComponent/ReducedPercentLenderComponent";
import { MapEmptyPricingRequest } from "src/pages/ferramentas/manual-calculation/MapEmptyPricingRequest";
import { CalculationRequestTypeEnum } from "src/services/interfaces/calculator/CalculationRequestTypeEnum";
import { IPricingCalculatorRequest } from "src/services/interfaces/calculator/IPricingCalculatorRequest";
import { IPricingCalculatorResponse } from "src/services/interfaces/calculator/IPricingCalculatorResponse";
import { IPricingParametersCalculator } from "src/services/interfaces/calculator/IPricingParametersCalculator";
import { IQuote } from "src/services/interfaces/trade/precificacao/IQuote";
import { MapQuote } from "src/services/mapper/quote.mapper";
import { ServiceContext } from "src/services/provider/Service.provider";
import { MoneyMask } from "src/util/Masks/MoneyMask";
import "./quote.scss";
import { objectPropsUpdate } from 'src/util/objectUtils';
import { ValidateCommissionFormat } from 'src/util/Validations';
import { pssAbsoluteRequired, validatePssAndShowMessage } from 'src/util/pssHelper';
import { CommissionSliderComponent } from 'src/components/PricingComponents/CommissionSliderComponent/CommissionSliderComponent'
import { SelectOfficer } from "src/components/common/SelectOfficer/SelectOfficer";
import { IUpdateQuotePricing } from "src/services/interfaces/trade/precificacao/IUpdateQuotePricing";
import { GetPersonType, PersonTypeEnum } from "src/util/GetPersonType";
import { BirthDateComponent } from "src/components/PricingComponents/BirthDateComponent/BirthDateComponent";
import { IPrecatorioCalculator } from "src/services/interfaces/calculator/IPrecatorioCalculator";
import { PbrFormItem } from "src/components/common/PbrFormItem/PbrFormItem";
import { Moment } from "moment";
import * as _ from "lodash";
interface IQuoteEditComponent {
  setLoading: Dispatch<SetStateAction<boolean>>;
  currentQuote: IQuote;
  setCurrentQuote: Dispatch<SetStateAction<Partial<IQuote>>>;
  setNewQuotePricingResponse: Dispatch<SetStateAction<IPricingCalculatorResponse>>;
  setIsVendaDisabled: Dispatch<SetStateAction<boolean>>;
  setConfirmQuoteDisabled: Dispatch<SetStateAction<boolean>>;
  setCurrentQuotePricingResponse: Dispatch<SetStateAction<IPricingCalculatorResponse>>;
}

function QuoteEditComponent({
  form,
  currentQuote,
  setCurrentQuote,
  setLoading,
  setNewQuotePricingResponse,
  setConfirmQuoteDisabled,
  setIsVendaDisabled,
  setCurrentQuotePricingResponse,
}: IQuoteEditComponent & FormComponentProps) {
  const { minPrice, maxPrice, reducedPercentLender, pss, pssAbsolute } = currentQuote.pricing;

  const minCommissionValue = currentQuote.pricing?.commission?.officer?.full?.minValue;
  const maxCommissionValue = currentQuote.pricing?.commission?.officer?.full?.maxValue;

  const officerMinCommissionValue = currentQuote.pricing?.commission?.officer?.userCommissionCalculated?.minValue;
  const officerMaxCommissionValue = currentQuote.pricing?.commission?.officer?.userCommissionCalculated?.maxValue;

  const { currentUser } = useContext(AuthContext);
  const { pricingService, quotePricingService } = useContext(ServiceContext);

  const [showPrecifyByOtherPartner, setShowPrecifyByOtherPartner] = useState(false);
  const [needToRePrecify, setNeedToPrecify] = useState(false);
  const [pricingRequest, setPricingRequest] = useState<IPricingCalculatorRequest>(MapEmptyPricingRequest(CalculationRequestTypeEnum.OfficerRecalculate));
  const [sliderValues, setSliderValues] = useState({ minPrice: 0, maxPrice: 0, minCommissionValue: 0, maxCommissionValue: 0 })
  const [isRecalculateDisabled, setIsRecalculateDisabled] = useState(false);
  const [updateQuotePricing, setUpdateQuotePricing] = useState<IUpdateQuotePricing>(null);
  const [isCessaoHonorarios, setIsCessaoHonorarios] = useState(false);
  const [hiddenCredorBirthDate, setHiddenCredorBirthDate] = useState<Moment>(undefined);
  const [desableUpdateQuote, setDesableUpdateQuote] = useState(false);

  const minCommission = officerMinCommissionValue ?? minCommissionValue
  const maxCommission = officerMaxCommissionValue ?? maxCommissionValue

  useEffect(() => {
    if (currentQuote !== null && currentQuote !== undefined) {
      setPricingRequest(MapQuote.ToPricingCalculatorRequest(currentQuote, CalculationRequestTypeEnum.OfficerRecalculate));
      setSliderValues({
        minPrice,
        maxPrice,
        minCommissionValue: officerMinCommissionValue ?? minCommissionValue,
        maxCommissionValue: officerMaxCommissionValue ?? maxCommissionValue
      });
      if (currentQuote.precatorio.credorBirthDate !== null) {
        setIsCessaoHonorarios(true)
      }
    }
  }, [currentQuote]);

  useEffect(() => {
    setShowPrecifyByOtherPartner(currentQuote.officer != null);
    handlePricingParametersRequest({ forceOfficerPrecification: currentQuote?.officer?.id })
  }, [currentQuote]);

  useEffect(() => {
    const reducerPercentChange = pricingRequest.pricingParameters?.reducedPercentLender !== reducedPercentLender;
    const pssChange = (pss > 0 || pssAbsolute > 0) !== pricingRequest.pricingParameters?.isPss;
    const birthdate = pricingRequest.precatorio.birthDate !== currentQuote.precatorio.birthDate;
    const credorBirthdate = !(_.isEmpty(pricingRequest.precatorio.credorBirthDate) && _.isEmpty(pricingRequest.precatorio.credorBirthDate)) && (pricingRequest.precatorio.credorBirthDate !== currentQuote.precatorio.credorBirthDate);
    const isSeriousIllness = pricingRequest.precatorio.isSeriousIllness !== currentQuote.precatorio.isSeriousIllness;
    const condition = (reducerPercentChange || pssChange || birthdate || credorBirthdate || isSeriousIllness);
    setNeedToPrecify(condition);
    setConfirmQuoteDisabled(condition);
    setIsVendaDisabled(condition);
    handleQuotePricing();
  }, [
    pricingRequest.pricingParameters?.isPss,
    pricingRequest.pricingParameters?.reducedPercentLender,
    pricingRequest.precatorio.birthDate,
    pricingRequest.precatorio.credorBirthDate,
    pricingRequest.precatorio.isSeriousIllness,
  ])

  function handlePricingParametersRequest(value: Partial<IPricingParametersCalculator>) {
    setPricingRequest(req => objectPropsUpdate(req, { pricingParameters: objectPropsUpdate(req.pricingParameters, { ...value }) }));
  }

  useEffect(() => {
    setHiddenCredorBirthDate(currentBirthDate => currentQuote.precatorio.credorBirthDate ?? currentBirthDate)
    handlePrecatorioChange("credorBirthDate")(!isCessaoHonorarios ? undefined : hiddenCredorBirthDate)
    ValidationDesableQuote()
  }, [isCessaoHonorarios]);

  useEffect(() => {
    ValidationDesableQuote()
  }, [pricingRequest.precatorio.credorBirthDate]);

  function ValidationDesableQuote() {
    if (pricingRequest.precatorio.credorBirthDate === null && isCessaoHonorarios) {
      setDesableUpdateQuote(true)
    } else {
      setDesableUpdateQuote(false)
    }
  }

  const handlePrecatorioChange = (property: keyof IPrecatorioCalculator) => (value) => {
    setPricingRequest(req => objectPropsUpdate(req, { precatorio: objectPropsUpdate(req.precatorio, { [property]: value }) }));
  }

  function handleQuotePricing() {
    const currentReducedPercent = pricingRequest.pricingParameters?.reducedPercentLender ? pricingRequest.pricingParameters?.reducedPercentLender : 1;
    setUpdateQuotePricing({
      credorBirthDate: pricingRequest.precatorio?.credorBirthDate,
      birthDate: pricingRequest.precatorio?.birthDate,
      forceOfficerPrecification: pricingRequest.pricingParameters?.forceOfficerPrecification,
      id: currentQuote.id,
      isPss: pricingRequest.pricingParameters?.isPss,
      pssAbsolute: pricingRequest.pricingParameters?.pssAbsolute,
      reducedPercentLender: currentReducedPercent,
      isSeriousIllness: pricingRequest.precatorio?.isSeriousIllness
    });
  }



  function updateQuotePricingParameters() {
    if (!validatePssAndShowMessage(pricingRequest.pricingParameters.isPss, pricingRequest.precatorio.principal, pricingRequest.pricingParameters?.pssAbsolute)) {
      return;
    }
    // credorBirthDateValidate()
    setLoading(true);
    quotePricingService
      .updateQuotePricingParameters(updateQuotePricing)
      .then(newQuote => {
        setNeedToPrecify(false);
        setConfirmQuoteDisabled(false);
        setCurrentQuote(newQuote);
        setCurrentQuotePricingResponse(MapQuote.ToPricingCalculatorResponse(newQuote));
        setNewQuotePricingResponse(null);
        setIsVendaDisabled(false);
      })
      .catch(() => notification.error({ message: "Falha ao reduzir %", description: "Ocorreu um erro ao reduzir o percentual do credor. Tente novamente." }))
      .finally(() => setLoading(false));
  }

  function recalculateQuote() {
    if (!validatePssAndShowMessage(pricingRequest.pricingParameters.isPss, pricingRequest.precatorio.principal, pricingRequest.pricingParameters?.pssAbsolute)) {
      return;
    }
    // credorBirthDateValidate()
    setLoading(true);
    setConfirmQuoteDisabled(true);
    setIsVendaDisabled(true);
    pricingService
      .calculatePrice(
        objectPropsUpdate(
          pricingRequest,
          {
            pricingParameters:
              objectPropsUpdate(
                pricingRequest.pricingParameters,
                { commission: ValidateCommissionFormat(pricingRequest.pricingParameters.commissionValue, true, pricingRequest.price) }
              )
          }
        )
      )
      .then(newPricing => {
        if (newPricing) {
          setConfirmQuoteDisabled(false);
          setNewQuotePricingResponse(newPricing.data);
          if (!newPricing.data.isRecalculateValid) {
            setConfirmQuoteDisabled(true);
            ShowNotification.Error("Não foi possivel recalcular", newPricing.message);
          }
        } else {
          ShowNotification.Error("Não foi possivel recalcular", "Tente novamente");
        }
      })
      .catch(() => notification.error({ message: "Falha no recálculo", description: "Ocorreu um erro durante o recálculo. Tente novamente." }))
      .finally(() => setLoading(false));
  }

  const handleSliderChange = (
    values: {
      min: number,
      max: number
    },
    pricingRequestUpdater:
      (req: Partial<IPricingCalculatorRequest>, value: number) =>
        Partial<IPricingCalculatorRequest>) =>
    (value: number) => {
      setIsVendaDisabled(true);
      setConfirmQuoteDisabled(true);

      if (!isNaN(value)) {
        if (Number(value.toFixed(2)) < Number(values.min.toFixed(2)) || Number(value.toFixed(2)) > Number(values.max.toFixed(2))) {
          setIsRecalculateDisabled(true);
        } else {
          setIsRecalculateDisabled(false);
          setPricingRequest(req => objectPropsUpdate(req, pricingRequestUpdater(req, value)))
        }
      }
    }

  return (
    <>
      {currentUser.permissions.canPrecifyByOtherPartner && (

        <Row>
          <div className="pricing-header">
            <span className="subtitle">Cotar com paramêtros de outro parceiro</span>
            <Switch
              className={"switch-input"}
              checkedChildren="Sim"
              unCheckedChildren="Não"
              checked={showPrecifyByOtherPartner}
              onChange={e => {
                setShowPrecifyByOtherPartner(e);
                if (!e) {
                  handlePricingParametersRequest({ forceOfficerPrecification: null });
                  if (currentQuote.officer != null) {
                    setNeedToPrecify(true);
                  }
                }
                else {
                  setNeedToPrecify(false);
                }
              }}
            />
            {showPrecifyByOtherPartner && (
              <>
                <Col xs={24} sm={24} md={24} lg={14}>
                  <SelectOfficer
                    form={form}
                    handleChange={e => handlePricingParametersRequest({ forceOfficerPrecification: Number(e.toString()) })}
                    value={pricingRequest.pricingParameters.forceOfficerPrecification}
                    isRequired={false} label="Selecione o Officer para cotar" />
                  <Button disabled={!pricingRequest.pricingParameters?.forceOfficerPrecification} className="btn right-input-side-button calculate-with-other-partner-button" onClick={updateQuotePricingParameters}>Atualizar cotação com parametros do parceiro</Button>
                </Col>
              </>
            )}
          </div>
        </Row>
      )}
      {!showPrecifyByOtherPartner && (
        <>
          <Row>
            <ReducedPercentLenderComponent pricingParameters={pricingRequest.pricingParameters} onChange={handlePricingParametersRequest} form={form} />
          </Row>
          {GetPersonType(currentQuote?.precatorio?.cpfCnpj) === PersonTypeEnum.PF &&
            <Row gutter={16}>
              <Col xs={24} sm={24} md={24} lg={14}>
                <PbrFormItem label="Possui doença grave?" required>
                  <Switch
                    checkedChildren="Sim"
                    unCheckedChildren="Não"
                    checked={pricingRequest.precatorio.isSeriousIllness}
                    onChange={handlePrecatorioChange("isSeriousIllness")}
                  />
                </PbrFormItem>
              </Col>
              <Col xs={24} sm={24} md={24} lg={14}>
                <BirthDateComponent
                  name="birthDate"
                  request={pricingRequest.precatorio.birthDate}
                  onChange={handlePrecatorioChange("birthDate")}
                  form={form}
                  label="Data de nascimento do Requerente"
                  required
                />
              </Col>
              <Col xs={24} sm={24} md={24} lg={14}>
                <PbrFormItem label="Aquisição refere-se a honorários contratuais?">
                  <Switch
                    checkedChildren="Sim"
                    unCheckedChildren="Não"
                    checked={isCessaoHonorarios}
                    onChange={e => setIsCessaoHonorarios(e)}
                  />
                </PbrFormItem>
              </Col>
              {isCessaoHonorarios &&
                <Col xs={24} sm={24} md={24} lg={10}>
                  <BirthDateComponent
                    name="credorBirthDate"
                    request={pricingRequest.precatorio.credorBirthDate}
                    onChange={handlePrecatorioChange("credorBirthDate")}
                    form={form}
                    label="Data de nascimento do Credor"
                    required
                  />
                </Col>}
            </Row>}
          <Row style={{ marginBottom: "15px" }}>
            <Col xs={24} sm={24} md={24} lg={10} style={{ marginTop: "10px" }}>
              <PSSComponent
                canEditPssAbsolute={pssAbsoluteRequired(pricingRequest.pricingParameters.isPss, pricingRequest.precatorio.principal)}
                canEditPssPercentual={false}
                pss={pricingRequest.pricingParameters.pss}
                pssabsolute={pricingRequest.pricingParameters.pssAbsolute}
                isPss={pricingRequest.pricingParameters.isPss}
                onChangePss={(pssParam) => handlePricingParametersRequest({ pss: pssParam })}
                onChangePssAbsolute={(pssAbsoluteParam) => handlePricingParametersRequest({ pssAbsolute: pssAbsoluteParam })}
                onChangeIsPss={(isPss) => handlePricingParametersRequest({ isPss })}
                form={form}
                pssAbsoluteRequired={pssAbsoluteRequired(pricingRequest.pricingParameters.isPss, pricingRequest.precatorio.principal)} />
            </Col>
            <Col xs={24} sm={24} md={24} lg={14}>
              <Button disabled={desableUpdateQuote} className="btn right-input-side-button" onClick={updateQuotePricingParameters}>Atualizar dados precatório</Button>
            </Col>
          </Row>
          {needToRePrecify && (
            <Row>
              <p className="error-message">Clique no botão para atualizar os dados do precatório</p>
            </Row>
          )}
        </>
      )}

      <CommissionSliderComponent
        form={form}
        maxPrice={currentQuote.pricing?.maxPrice}
        minPrice={currentQuote.pricing?.minPrice}
        price={pricingRequest?.price}
        maxCommission={maxCommission}
        minCommission={minCommission}
        commission={pricingRequest.pricingParameters?.commissionValue}
        handleChangeValue={(price, commission, changeType) => {
          handleSliderChange(
            changeType === "price" ? { min: minPrice, max: maxPrice } : { min: minCommissionValue, max: maxCommissionValue },
            (req, p) => {
              form.setFieldsValue({
                commission,
                price
              });
              return {
                price,
                pricingParameters: objectPropsUpdate(req.pricingParameters, { commissionValue: commission })
              }
            }
          )(changeType === "price" ? price : commission)
        }
        }
        needToPrecifyPercentLender={needToRePrecify}
        canEditQuotePrice={currentUser.permissions.canEditQuotePrice}
      />
      {isRecalculateDisabled && (
        <>
          <p className="error-message">
            {`Comissão fora dos limites Minimo: ${MoneyMask(sliderValues.minCommissionValue)} - Máximo: ${MoneyMask(sliderValues.maxCommissionValue)}`}
          </p>
          <p className="error-message">
            {`Preço fora dos limites Minimo: ${MoneyMask(sliderValues.minPrice)} - Máximo: ${MoneyMask(sliderValues.maxPrice)})`}
          </p>
        </>
      )}
      {currentUser.permissions.canEditQuotePrice &&
        <Row style={{ textAlign: "center", marginTop: "40px" }}>
          <StandardButton style={{ color: "white" }} onClick={() => recalculateQuote()} disabled={isRecalculateDisabled || needToRePrecify}>
            Recalcular cotação
          </StandardButton>
        </Row>
      }
    </>
  );
}

export default QuoteEditComponent;



// WEBPACK FOOTER //
// ./src/pages/monitor/my-quotes/QuoteEditComponent.tsx